import { LineSeriesType } from "@mui/x-charts";

import { AssessmentVertical } from "graphql-types/graphql";

export type ConsumptionChartData = {
    period: string;
    waterTenant?: number;
    waterLandlord?: number;
    heatingTenant?: number;
    heatingLandlord?: number;
    electricityTenant?: number;
    electricityLandlord?: number;
};

export const verticals = [
    AssessmentVertical.ELECTRICITY,
    AssessmentVertical.HEATING,
    AssessmentVertical.WATER,
];
export type BenchmarkProperties = {
    id: string;
    segment: string;
    benchmark: string;
    label: string;
};

export type BenchmarkSeries = LineSeriesType & BenchmarkProperties;

export type ConsumptionSeries = {
    vertical: AssessmentVertical;
} & Omit<LineSeriesType, "type">;
